var INFIX = ' splitio => rum-agent: ';
export var log = {
    debug: function (m) { console.log('[DEBUG]' + INFIX + m); },
    info: function (m) { console.log('[INFO] ' + INFIX + m); },
    warn: function (m) { console.log('[WARN] ' + INFIX + m); },
    error: function (m) { console.log('[ERROR]' + INFIX + m); }
};
